// extracted by mini-css-extract-plugin
module.exports = {"hostInformation":"styles_hostInformation__AgIMk","hostInformation__content":"styles_hostInformation__content__k4eWJ"};